// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles'; // eslint-disable-line import/no-unresolved

// Vuetify
import { createVuetify } from 'vuetify';

export default createVuetify();
